import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';

import * as API from 'app/public_api';
import * as T from 'utils/types';

const rFcltDeptStat = createAsyncThunk(
    'smtPubFilter/rFcltDeptStat', 
    async (data:{
        searchInput: T.searchInput,
        keywordType: T.keywordType,
    }, thunkAPI)=>{
        return await API.rFcltDeptStat_SmtPub(
            data.searchInput,
            data.keywordType,
        );
    }
)

export const smtPubFilterThunks = {rFcltDeptStat};




export const initialState: T.SmtPubFilterState = {
    fcltDeptStat: {total:0, fclts:[], depts:[]},
    status: 'idle',
    errorMsg: null,
    currentRequestId: null,
}

// smtSearchPageS: summitSearchPageSlice
const smtPubSearchPageS =  createSlice({
    name: 'smtPubSearchPage',
    initialState,
    reducers: {},    
    extraReducers: builder=>{
        builder.addCase(rFcltDeptStat.pending, (state, action) => {
            state.status = 'loading';
            state.currentRequestId = action.meta.requestId;
        });
        builder.addCase(rFcltDeptStat.fulfilled, (state, action) => {
            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.currentRequestId){
                state.status = 'succeeded';
                state.fcltDeptStat = action.payload;
            }
        });
        builder.addCase(rFcltDeptStat.rejected, (state, action) => {
            // below line makes sure the response comes from the most recent request
            if(action.meta.requestId===state.currentRequestId){
                state.status = 'failed';
                state.errorMsg = action.error.message;
            }
        });
    }

});

export default smtPubSearchPageS;